/** @format */

import React from 'react';
import { Flex, Text, IconButton, Box } from '@chakra-ui/react';
import { toast, ToastOptions, Slide, TypeOptions } from 'react-toastify';

import CloseIcon from '../../assets/icons/toast/CloseIcon';
import SuccessIcon from '../../assets/icons/toast/SuccessIcon';
import WarningIcon from '../../assets/icons/toast/WarningIcon';
import ErrorIcon from '../../assets/icons/toast/ErrorIcon';

interface ToastProps {
  message: string;
  title?: string;
  type: TypeOptions;
}

// eslint-disable-next-line no-shadow
export enum ToastType {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
  default = 'default',
}

const ToastUI: React.FC<ToastProps> = ({ message, type, title }) => {
  const stateIcon = {
    [ToastType.info]: '',
    [ToastType.success]: <SuccessIcon />,
    [ToastType.warning]: <WarningIcon />,
    [ToastType.error]: <ErrorIcon />,
    [ToastType.default]: '',
  };

  const headlineText = {
    [ToastType.info]: '',
    [ToastType.success]: 'Success',
    [ToastType.warning]: 'Warning',
    [ToastType.error]: 'Error',
    [ToastType.default]: '',
  };

  return (
    <Flex
      width={{ base: '100%', md: '546px' }}
      borderRadius='16px'
      alignItems='center'
      p={{ base: '10px', md: '16px' }}
      justifyContent='space-between'
      style={{
        background: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #EFF1F6',
        boxShadow:
          '0px 16px 32px rgba(219, 222, 229, 0.1), 0px 12px 24px rgba(219, 222, 230, 0.1), 0px 8px 16px 4px rgba(188, 196, 204, 0.1)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Flex columnGap='12px' alignItems='center'>
        <Box>{stateIcon[type]}</Box>
        <Flex flexDir='column' justifyContent='space-between' ml='5px' fontFamily={'Poppins'}>
          <Text
            color='black'
            fontSize={{ base: '16px', md: '20px' }}
            fontWeight={600}
            fontFamily={'Poppins'}
          >
            {title || headlineText[type]}
          </Text>
          <Text color={'black'} fontFamily={'Poppins'} fontSize={{ base: '12px', md: '16px' }}>
            {message}
          </Text>
        </Flex>
      </Flex>

      <Flex alignSelf='flexstart' ml='5px'>
        <IconButton aria-label='close-toaster'>
          <CloseIcon />
        </IconButton>
      </Flex>
    </Flex>
  );
};

const toastOptions = (autoClose?: number, id?: string): ToastOptions => {
  return {
    autoClose: autoClose || 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    transition: Slide,
    rtl: false,
    closeButton: false,
    toastId: id,
  };
};

export default function customToast(
  message: string,
  type: TypeOptions,
  title?: string,
  autoClose?: number,
  id?: string,
) {
  toast(<ToastUI message={message} type={type} title={title} />, toastOptions(autoClose, id));
}
